import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import { baseURL } from "../../../../config/api";
import useAuth from "../../../../hook/useAuth";
import useConfirm from "../../../../hook/useConfirm";
import useDelete from "../../../../hook/useDelete";

export const EditVendorStatus = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const idNumber = useLocation();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [statusName, setStatusName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [vendorStatusData, setVendorStatusData] = useState<any>(null);

    useEffect(() => {
        setPleaseWaitPopup(true);
        axios
            .get(`${baseURL}statuses/${idNumber?.state}`)
            .then((response) => {
                setVendorStatusData(response?.data);
                setStatusName(response?.data?.statusValue);
                setDescription(response?.data?.description);
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .put(
                `${baseURL}statuses?userId=${auth?.id}`,
                JSON.stringify({
                    ...vendorStatusData,
                    statusValue: statusName,
                    description
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const deletingVendorStatus = async (id: number) => {
        setDeleteData({
            id: id,
            title: `Delete Vendor Status`,
            summary: `Are you sure you want to delete this Vendor Status?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();

                axios
                    .delete(`${baseURL}statuses?id=${id}&userId=${auth?.id}`)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setConfirmData({
                            title: "Warning",
                            summary: error.response?.data || "Delete failed.",
                            confirmBtn: "Ok",
                            isConfirm: (cb: any) => cb(),
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    });
            },
        });

        setDeletePopup(true);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Edit Vendor Status</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    <div>
                                        <label className="block text-xs font-medium text-secondary">Status Name</label>
                                        <input
                                            type="text"
                                            className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            value={statusName}
                                            placeholder="Status Name"
                                            onChange={(e) => setStatusName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-xs font-medium text-secondary">Description</label>
                                        <textarea
                                            rows={2}
                                            className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            value={description}
                                            placeholder="Description"
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => deletingVendorStatus(vendorStatusData?.statusID)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-red-500 text-white cursor-pointer border border-red-600"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>

    )
}